import { render, staticRenderFns } from "./CsaCerrado.vue?vue&type=template&id=84d835be&lang=pug"
import script from "./CsaCerrado.vue?vue&type=script&lang=js"
export * from "./CsaCerrado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports